import React from 'react';

export default function Textarea({ value, onChange, placeholder, rows = 4, ...props }) {
  return (
    <textarea
      className="w-full p-2 border border-gray-300 rounded"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      {...props}
    />
  );
}